import { useMemo, useState } from 'react';
import FeedEditor from './FeedEditor'
import DashboardScreen from './DashboardScreen'
import Notification from '../Global/Notification';
import ConfirmDialog from '../Global/ConfirmDialog';
import SettingsPage from './SettingsPage';
import AboutPage from './AboutPage';
import SupportPage from './SupportPage';
import UpsellPopupModal from '../Modals/UpsellPopupModal';
import SbUtils from '../../Utils/SbUtils';

const HomeScreen = () => {
    const sbCustomizer = window.sb_customizer;
    const [ loader, setLoader ] = useState( false );
    const isPro = sbCustomizer?.isPro && sbCustomizer?.isPro ? true : false;
    const isSocialWallActive = sbCustomizer?.isSocialWallActive && sbCustomizer?.isSocialWallActive ? true : false;

    const editorTopLoader = useMemo(
        () => ({ loader, setLoader }),
		[ loader, setLoader ]
    );

    const [ notification, setNotification ] = useState({
        active : false
    });
    const editorNotification = useMemo(
        () => ({ notification, setNotification }),
		[ notification, setNotification ]
    );


    const [ confirmDialog, setConfirmDialog ] = useState({
        active : false
    });

    const editorConfirmDialog = useMemo(
        () => ({ confirmDialog, setConfirmDialog }),
		[ confirmDialog, setConfirmDialog ]
    );

    const [ addApiKeyModal, setAddApiKeyModal ] = useState( {
        active : false
    } );
    const apiKeyModal = useMemo(
        () => ({ addApiKeyModal, setAddApiKeyModal}),
		[addApiKeyModal, setAddApiKeyModal]
    );

    // Check for Source Connect Modal.
    const [connectSourceActive, setConnectSourceActive] = useState(sbCustomizer?.newSourceData !== undefined);
    const connectSourceModal = useMemo(
        () => ({ connectSourceActive, setConnectSourceActive }),
        [connectSourceActive, setConnectSourceActive]
    );

    const [tiers, setTiers] = useState(sbCustomizer?.pluginStatus?.license_tier ?? 'free');
    const allowedTiers = useMemo(
        () => ({ tiers, setTiers }),
		[tiers, setTiers]
    );

    const [ pluginSettings , setPluginSettings ] = useState( sbCustomizer?.pluginSettings );

    const globalSettings = useMemo(
        () => ({ pluginSettings , setPluginSettings }),
		[ pluginSettings , setPluginSettings ]
    );


    const [ upsellActive , setUpsellActive ] = useState( false );
    const upsellModal = useMemo(
        () => ({ upsellActive , setUpsellActive }),
		[ upsellActive , setUpsellActive  ]
    );

    const [ feedData, setFeedData ] = useState( sbCustomizer?.feedData || []  );
    const editorFeedData = useMemo(
        () => ({ feedData, setFeedData }),
		[feedData, setFeedData]
    );

    const [ apiKeys, setApiKeys ] = useState( sbCustomizer.apiKeys || [] );
    const apis = useMemo(
        () => ({ apiKeys, setApiKeys }),
		[apiKeys, setApiKeys]
    );

    const [ apiKeyLimits, setApiKeyLimits  ] = useState( sbCustomizer.apiKeyLimits || [] );
    const apiLimits = useMemo(
        () => ({ apiKeyLimits, setApiKeyLimits }),
		[apiKeyLimits, setApiKeyLimits]
    );



    const [ topNoticeBar, setTopNoticeBar ] = useState({});
    const noticeBar = useMemo(
        () => ({ topNoticeBar, setTopNoticeBar  }),
		[ topNoticeBar, setTopNoticeBar ]
    );

    const noticeBarMemo = useMemo(
        () => SbUtils.checkAPIKeys(noticeBar, topNoticeBar, feedData, isPro, isSocialWallActive ),
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [ noticeBar, topNoticeBar, feedData ]
    );

    //const [ topNoticeBarActive, setTopNoticeBarActive ] = useState(false);
    const topNoticeBarActive = useMemo( () => {
        let isActive = false
        if( noticeBarMemo !== undefined ){
            Object.keys(noticeBarMemo.topNoticeBar)?.forEach( ( nbr, nbKey ) => {
               nbr = noticeBarMemo.topNoticeBar[nbr];
               if( nbr.active === true )
                   isActive = true;
            });
        }

        return isActive;
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[topNoticeBar, apiKeys]);

    const [ licenseUpgradeData, setLicenseUpgradeData ] = useState(
        {
            isLicenseUpgraded: sbCustomizer?.isLicenseUpgraded || false,
            licenseUpgradedInfo: sbCustomizer?.licenseUpgradedInfo || false
        }
    );

    const proLicenseMemo = useMemo(
        () => ({ licenseUpgradeData, setLicenseUpgradeData  }),
		[ licenseUpgradeData, setLicenseUpgradeData ]
    );

    return (
        <>
            { //DashBoard Screen
                (!sbCustomizer.isFeedEditor && sbCustomizer.reactScreen === 'customizer') &&
                <DashboardScreen
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    apiKeyModal={ apiKeyModal }
                    connectSourceModal={ connectSourceModal }
                    globalSettings={ globalSettings }
                    allowedTiers={ allowedTiers }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                />
            }

            { //Feed Editor
               ( sbCustomizer.isFeedEditor && sbCustomizer.reactScreen === 'customizer')  &&
                <FeedEditor
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    apiKeyModal={ apiKeyModal }
                    connectSourceModal={ connectSourceModal }
                    allowedTiers={ allowedTiers }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                />
            }

            { //Settings Page
               sbCustomizer.reactScreen === 'settings' &&
                <SettingsPage
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    apiKeyModal={ apiKeyModal }
                    connectSourceModal={ connectSourceModal }
                    allowedTiers={ allowedTiers }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                    proLicenseMemo={proLicenseMemo}
                />
            }

            { //About Us Page
               sbCustomizer.reactScreen === 'aboutus' &&
                <AboutPage
                    sbCustomizer={ sbCustomizer }
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                />
            }

            { //Support Page
               sbCustomizer.reactScreen === 'support' &&
                <SupportPage
                    sbCustomizer={ sbCustomizer }
                    editorTopLoader={ editorTopLoader }
                    editorNotification={ editorNotification }
                    editorConfirmDialog={ editorConfirmDialog }
                    isPro={ isPro }
                    upsellModal={ upsellModal }

                    editorFeedData={editorFeedData}
                    apis={apis}
                    apiLimits={apiLimits}
                    noticeBar={noticeBar}
                    noticeBarMemo={noticeBarMemo}
                    topNoticeBarActive={topNoticeBarActive}
                />
            }

            <Notification
                active={ editorNotification.notification?.active }
                icon={ editorNotification.notification?.icon }
                text={ editorNotification.notification?.text }
                type={ editorNotification.notification?.type }
            />
            <ConfirmDialog
                active={ editorConfirmDialog.confirmDialog?.active }
                heading={ editorConfirmDialog.confirmDialog?.heading }
                description={ editorConfirmDialog.confirmDialog?.description }
                confirm={ editorConfirmDialog.confirmDialog?.confirm }
                cancel= { editorConfirmDialog.confirmDialog?.cancel }
                onClose = { () => {
                    editorConfirmDialog.setConfirmDialog({
                        active : false
                    });
                } }
            />

            <UpsellPopupModal
                upsellModal={upsellModal}
                upsellContent={sbCustomizer?.upsellContent}
            />
        </>
    )
}

export default HomeScreen;